import React from "react";
import { TextField } from "@mui/material";
import EntityForm from "../../../../helpers/EntityForm";

const ImageForm = ({
  image,
}) => {
  return (
    <EntityForm isCreate={image === null}>
      <input name="imageEntityId" readOnly hidden value={image?.imageEntityId}/>
      <TextField
        label="Name"
        type="text"
        id="imageName"
        name="imageName"
        required
        defaultValue={image?.imageName}
        variant="outlined"
      />
      <TextField
        label="Credit"
        type="text"
        id="imageCredit"
        name="imageCredit"
        required={false}
        defaultValue={image?.imageCredit}
        variant="outlined"
      />
      <TextField
        label="Label"
        type="text"
        id="imageLabel"
        name="imageLabel"
        required={false}
        defaultValue={image?.imageLabel}
        variant="outlined"
      />
      <TextField
        label="Type"
        type="text"
        id="imageType"
        name="imageType"
        required={false}
        defaultValue={image?.imageType}
        variant="outlined"
      />
      <TextField
        label="Url"
        type="text"
        id="imageUrl"
        name="imageUrl"
        required={false}
        defaultValue={image?.imageUrl}
        variant="outlined"
      />
    </EntityForm>
  );
};

export default ImageForm;